export default {
  male: '남성',
  female: '여자',
} as const;
